import { Tab } from '@headlessui/react'
import classNames from 'classnames'
import { propOr } from 'ramda'

import useProgram from '../stores/use-program'

const programSelector = propOr(null, 'program')

const Reviews = () => {
  const program = useProgram(programSelector)

  return (
    <Tab.Panel className='-mb-10  '>
      <>
        <h3 className='sr-only'>Customer Reviews</h3>
        {program &&
          program.reviews.map((reviewObject, reviewIdx) => (
            <div
              className='flex space-x-4 text-sm text-gray-500'
              key={program.reviews.indexOf(reviewObject)}
            >
              <div
                className={classNames(
                  reviewIdx === 0 ? '' : 'border-t border-gray-200',
                  'py-10',
                )}
              >
                <div
                  className=' custom-font-24  mt-2  max-w-none'
                  /* eslint-disable-next-line react/no-danger */
                >
                  <p className='italic text-black'>{reviewObject.review}</p>
                  <p className='relative  text-gray-500'>- (anonymous)</p>
                </div>
              </div>
            </div>
          ))}
      </>
      <style jsx>{`
        .reviewAuthor {
          font-size: calc(16px + (30 - 16) * (100vw - 375px) / (1920 - 375));
          font-weight: 500;
        }
        .reviewDate {
          font-size: calc(10px + (20 - 10) * (100vw - 375px) / (1920 - 375));
          font-weight: 300;
        }
      `}</style>
    </Tab.Panel>
  )
}

export default Reviews
